import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";

export const Cards = () => {
  const projects = [
    {
      title: "Selenium",
      description: "Automated Testing Script for e-commerce Website",
      details: "Developed automated testing scripts using Selenium WebDriver for e-commerce platforms.",
      tech: ["Selenium", "Python", "WebDriver"],
      gradient: "from-blue-500 to-cyan-500"
    },
    {
      title: "Pymongo & Boto3",
      description: "Database & Cloud Automation",
      details: "Scripts to alter MongoDB database and automated scripts to upload images for websites and create links.",
      tech: ["Python", "MongoDB", "AWS S3", "Boto3"],
      gradient: "from-yellow-500 to-orange-500"
    },
    {
      title: "Docker",
      description: "Container and Orchestration",
      details: "Implemented containerization and orchestration solutions for applications.",
      tech: ["Docker", "Containerization"],
      gradient: "from-red-500 to-pink-500"
    },
    {
      title: "AWS",
      description: "Cloud Infrastructure",
      details: "AWS Batch - Containerized Python rembg and deployed to AWS. AWS EventBridge to trigger batch jobs when uploading to S3.",
      tech: ["AWS Batch", "EventBridge", "S3", "Python"],
      gradient: "from-green-500 to-teal-500"
    },
    {
      title: "Flask",
      description: "Backend API Development",
      details: "A CRUD application model for internal 3D modeller's Website for AWS actions. An internal file transfer API.",
      tech: ["Flask", "Python", "REST API", "AWS"],
      gradient: "from-gray-500 to-slate-500"
    },
    {
      title: "React.js",
      description: "Frontend Development",
      details: "Maintained e-commerce website, unified multiple product pages, implemented search feature, and built various web applications.",
      tech: ["React.js", "JavaScript", "Frontend"],
      gradient: "from-orange-500 to-red-500"
    },
    {
      title: "Supabase",
      description: "Backend as a Service",
      details: "Used Supabase as a Backend service for internal websites and applications.",
      tech: ["Supabase", "Backend", "Database"],
      gradient: "from-purple-500 to-indigo-500"
    },
    {
      title: "Node.js",
      description: "Server-Side JavaScript",
      details: "Maintaining and adding modifications for e-commerce website modules.",
      tech: ["Node.js", "JavaScript", "Backend"],
      gradient: "from-indigo-500 to-purple-500"
    },
    {
      title: "Next.js",
      description: "Full-Stack React Framework",
      details: "Currently developing web applications for ChangeBegins.ai (Maaya Analytics) using Next.js, working as part of the tech team to build innovative solutions.",
      tech: ["Next.js", "React", "Frontend"],
      gradient: "from-emerald-500 to-green-500",
      link: "https://www.changebegins.ai"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
      {projects.map((project, index) => (
        <div
          key={index}
          className="group relative bg-slate-800/60 backdrop-blur-md border border-blue-500/20 rounded-2xl p-6 hover:bg-slate-700/60 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/30 hover:border-blue-400/40"
        >
          {/* Gradient Background */}
          <div className={`absolute inset-0 bg-gradient-to-br ${project.gradient} opacity-0 group-hover:opacity-10 rounded-2xl transition-opacity duration-300`}></div>
          
          {/* Content */}
          <div className="relative z-10">
            <div className="flex items-start justify-between mb-4">
              <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                {project.title}
              </h3>
              {project.link && (
                <a
                  href={project.link}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white/60 hover:text-white transition-colors"
                >
                  <FaExternalLinkAlt className="w-4 h-4" />
                </a>
              )}
            </div>
            
            <p className="text-blue-300 font-semibold mb-3 bg-gradient-to-r from-blue-300 to-cyan-300 bg-clip-text text-transparent" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              {project.description}
            </p>
            
            <p className="text-gray-300 text-sm mb-4 leading-relaxed" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              {project.details}
            </p>
            
            {/* Tech Stack */}
            <div className="flex flex-wrap gap-2">
              {project.tech.map((tech, techIndex) => (
                <span
                  key={techIndex}
                  className="px-3 py-1 bg-white/10 backdrop-blur-sm rounded-full text-xs text-white/80 border border-white/20"
                  style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}
                >
                  {tech}
                </span>
              ))}
            </div>
          </div>
          
          {/* Hover Effect */}
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-600/0 to-cyan-600/0 group-hover:from-blue-600/10 group-hover:to-cyan-600/10 transition-all duration-300"></div>
        </div>
      ))}
    </div>
  );
};
